import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, from, Observable, of, take } from "rxjs";
declare const Meteor: any;
export interface User {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    name: string;
    picture: string;
    photoURL: string;
    createdAt: string;
    loginMethod: 'email' | 'google' | 'facebook' | 'twitter' | 'linkedin' | 'github' | 'microsoft' | 'apple' | 'other';
    sub?: any;
}

export interface LoginResponse {
    success: boolean;
    message?: string;
    user?: User;
}

@Injectable({
    providedIn: 'root'
})
export class AuthService implements OnDestroy {

    private currentUserSubject = new BehaviorSubject<User | null>(null);
    public user$: Observable<User | null> = this.currentUserSubject.asObservable();
    private tokenSubject = new BehaviorSubject<any>({});

    constructor() {
      this.refreshUser();
    }

    /**
     * Re-read user from sessionStorage and push to user$.
     * Call after login/auth-callback or on app init so the whole app has current user data.
     */
    refreshUser(): void {
      try {
        const raw = sessionStorage.getItem('tokenPayload');
        if (!raw || raw === '{}') {
          this.currentUserSubject.next(null);
          return;
        }
        const payload = JSON.parse(raw);
        const user = payload?.profile ?? payload;
        user._id = payload?._id;
        this.currentUserSubject.next(user && typeof user === 'object' ? user : null);
      } catch {
        this.currentUserSubject.next(null);
      }
    }

    getTokenFromCode(code: string, redirectUri: string): Observable<any> {
        Meteor.call('getTokenFromCode', code, redirectUri, (error: Error | null, response: any) => {
            if (error) {
                this.tokenSubject.error(error);
            } else {
                this.tokenSubject.next(response);
            }
        });
        return this.tokenSubject.asObservable();
    }


    getAccessTokenSilently(): Observable<string | null> {
        const token: string | null = sessionStorage.getItem('token');
        return of(token || null);
    }

    getUserProfile(): Observable<User | null> {
        this.refreshUser();
        return this.user$;
    }

    loginWithRedirect(params: any) {
        console.log('loginWithRedirect', params);
    }

    logout(callback: any) {
        sessionStorage.clear();
        this.currentUserSubject.next(null);
        callback?.openUrl?.();
    }

    ngOnDestroy(): void {

    }

}
